export const SET_ACCESS_TOKEN = "AUTH/SET_ACCESS_TOKEN";
export const SET_REFRESH_TOKEN = "AUTH/SET_REFRESH_TOKEN";
export const SET_CURRENT_USER = "AUTH/SET_CURRENT_USER";
export const SET_IS_LOADING = "AUTH/SET_IS_LOADING";
